var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMsgInfo2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#9EA0A5",
    cx: 8,
    cy: 8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.504 10.431c0-.518.058-.91.176-1.176.117-.265.373-.59.768-.972.543-.527.904-.926 1.083-1.197.18-.272.269-.626.269-1.062 0-.72-.244-1.312-.731-1.775-.488-.463-1.137-.694-1.948-.694-.877 0-1.566.27-2.068.811-.502.542-.753 1.257-.753 2.145h1.099c.02-.535.105-.944.253-1.228.263-.51.739-.765 1.426-.765.555 0 .953.148 1.194.444.241.296.361.646.361 1.05 0 .288-.082.565-.247.833-.09.152-.21.298-.358.438l-.493.488c-.474.465-.78.877-.92 1.237-.14.36-.21.835-.21 1.423h1.099zm.105 2.309v-1.284H7.38v1.284H8.61z",
    fill: "#9EA0A5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMsgInfo2);
export default __webpack_public_path__ + "static/media/ico-msg-info-2.e289f9ef10f33df91b4ea1ab887bd133.svg";
export { ForwardRef as ReactComponent };